var map = {
	"./__mocks__/languageMock": 68,
	"./__mocks__/languageMock.js": 68,
	"./languages.demo.digvurd.gb-en": 49,
	"./languages.demo.digvurd.gb-en.json": 49,
	"./languages.demo.digvurd.nb-no": 50,
	"./languages.demo.digvurd.nb-no.json": 50,
	"./languages.gb-en": 51,
	"./languages.gb-en.json": 51,
	"./languages.hiof.gb-en": 52,
	"./languages.hiof.gb-en.json": 52,
	"./languages.hiof.nb-no": 53,
	"./languages.hiof.nb-no.json": 53,
	"./languages.nb-no": 54,
	"./languages.nb-no.json": 54,
	"./languages.uit.gb-en": 55,
	"./languages.uit.gb-en.json": 55,
	"./languages.uit.nb-no": 56,
	"./languages.uit.nb-no.json": 56,
	"./languages.usn.gb-en": 57,
	"./languages.usn.gb-en.json": 57,
	"./languages.usn.nb-no": 58,
	"./languages.usn.nb-no.json": 58,
	"./languages.usn.vernepleie.gb-en": 59,
	"./languages.usn.vernepleie.gb-en.json": 59,
	"./languages.usn.vernepleie.nb-no": 60,
	"./languages.usn.vernepleie.nb-no.json": 60,
	"./languages.vid.gb-en": 61,
	"./languages.vid.gb-en.json": 61,
	"./languages.vid.nb-no": 62,
	"./languages.vid.nb-no.json": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;